/**
 * Canonical API base URLs for the GeoVera WebGIS frontend.
 *
 * Production (App Hosting): leave VITE_API_URL empty / "same-origin" so the browser
 * calls `/api/*` on geovera.in. The SPA server proxies those to the Cloud Run backend.
 * That keeps Google OAuth on the same host (no broken api.geovera.in DNS).
 *
 * Local dev: defaults to docker-compose backend on :3001.
 */

function resolveApiOrigin(): string {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim().replace(/\/$/, '');
  if (!raw || raw === 'same-origin' || raw === '/') {
    // Dev: hit backend directly. Prod build: same-origin relative URLs.
    return import.meta.env.DEV ? 'http://localhost:3001' : '';
  }
  return raw;
}

export const API_ORIGIN = resolveApiOrigin();

export const API_BASE = API_ORIGIN ? `${API_ORIGIN}/api` : '/api';

export const DIGIPIN_CLOUD_API_URL =
  (import.meta.env.VITE_DIGIPIN_API_URL as string | undefined)?.replace(/\/$/, '') ||
  'https://digipin-api-661811805056.asia-south1.run.app';

export const GEOVERA_WEB_URL =
  (import.meta.env.VITE_WEB_URL as string | undefined)?.replace(/\/$/, '') || 'https://geovera.in';

/** Default request timeout for browser → backend */
export const DEFAULT_API_TIMEOUT_MS = 15_000;
